export const VIP_BANNER = {
  bannerDesc:
    'Handpicked exclusive deals with limited availability from our top merchants, especially for you !',
  bannerTitle: 'Your Exclusive Deals',
  vip: 'VIP',
};
